import { isString } from "lodash";
import { redirect, useParams } from "react-router-dom";
import LinkMenuView from "./LinkMenuView";

const TripAdvisorLink = () => {
  const params = useParams();
  const shortCode = isString(params?.shortCode) && params?.shortCode;
  const link = shortCode && links[shortCode];

  if (shortCode) {
    if (shortCode === "gafe") {
      return <LinkMenuView link="gafe" />;
    } else if (link) {
      window.location.replace(link);
    }
    return null;
  } else {
    return <div />;
  }
};

const links: any = {
  taphouse:
    "https://www.tripadvisor.com/UserReviewEdit-g297896-d8677611-Tap_House_By_Trio-Galle_Galle_District_Southern_Province.html",
  amenti: "https://maps.app.goo.gl/ejTESrE2ymGy94QYA",
  gafe: "https://www.tripadvisor.com/UserReviewEdit-g297896-d28651263-Gafe-Galle_Galle_District_Southern_Province.html",
};

export default TripAdvisorLink;
